import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from './reducers';

const composedMiddleware = composeWithDevTools(applyMiddleware(thunk));

const store = createStore(reducers, composedMiddleware);

export default store;